module.exports = __webpack_public_path__ + "img/product1ap.1f7c1c9d.png";